import { PILL } from 'dashboard/templates/components/Parts/Medication/administration';

export function getOfficialName(nameList) {
  return nameList.find((item) => item.use === 'official') || {};
}

export function getFirstName(name) {
  return name.given && name.given.length ? name.given.join(' ') : '';
}

export function getLastName(name) {
  return name.family || '';
}

export function getFullOfficialName(patient) {
  const name = getOfficialName(patient.name);
  const firstName = getFirstName(name);
  const lastName = getLastName(name);

  return `${firstName} ${lastName}`;
}

export function getTimeConditionOperator(startDate, endDate) {
  if (startDate && endDate) {
    return 'between';
  } else if (startDate && !endDate) {
    return 'gte';
  } else if (!startDate && endDate) {
    return 'lte';
  } else {
    return '';
  }
}

export function getHealthParameterNodeByCode(healthParameterNodes, code) {
  return healthParameterNodes.find((node) => {
    const coding = (node.code && node.code.coding) || [];
    return !!coding.find((item) => item.code === code);
  }) || {};
}

export function getHealthParameterValueByCode(healthParameterNodes, code, nodeValueQuantityTarget = 'valueQuantity') {
  const node = getHealthParameterNodeByCode(healthParameterNodes, code);
  const valueQuantity = node[nodeValueQuantityTarget] || {};
  return valueQuantity.value ? `${valueQuantity.value}` : '';
}

function getMedicationAdministrationCode(medication = {}) {
  const form = medication.form || {};
  const coding = form.coding || [];

  if (!coding.length) return PILL;

  const codingObj = coding[0] || {};
  return codingObj.code || PILL;
}

function getMedicationDosages(dosage = {}) {
  const doseAndRate = dosage.doseAndRate || [];

  return doseAndRate.reduce((accumulator, currentItem) => {
    if (currentItem && currentItem.doseQuantity) {
      return [...accumulator, {
        value: currentItem.doseQuantity.value,
        unit: currentItem.doseQuantity.code,
        id: currentItem.id,
      }];
    }

    return accumulator;
  }, []);
}

function getMedicationClasses(medication) {
  const classes = medication.classes || [];

  return classes.reduce((accumulator, currentItem) => {
    if (currentItem && currentItem.key) {
      return [...accumulator, currentItem.key];
    }

    return accumulator;
  }, []);
}

export function convertMedicationSchedule(medicationSchedule = {}) {
  const medication = medicationSchedule.medication || {};
  const dosage = medicationSchedule.dosage || {};
  const schedule = medicationSchedule.schedule || {};

  return {
    id: medicationSchedule.id,
    name: medication.name,
    type: medication.medicationType || 'cardio',
    recommended: medicationSchedule.recommended,
    administration: getMedicationAdministrationCode(medication),
    dosages: getMedicationDosages(dosage),
    intakeMoments: [],
    schedule: {
      intervals: schedule.intervals && schedule.intervals.length
        ? schedule.intervals.map((item) => ({
          interval: item.interval,
          intervalOn: item.intervalOn,
        })) : [{ interval: 'P1D', intervalOn: true }],
      monthsOfYear: schedule.monthsOfYear || [],
      daysOfMonth: schedule.daysOfMonth || [],
      daysOfWeek: schedule.daysOfWeek || [],
      weeksOfMonth: schedule.weeksOfMonth || [],
      weeksOfYear: schedule.weeksOfYear || [],
      times: schedule.times || [],
      anchorDate: schedule.anchorDate || '',
      note: schedule.note || '',
    },
    classes: getMedicationClasses(medication),
    morningAmount: medicationSchedule.morningAmount || 0,
    noonAmount: medicationSchedule.noonAmount || 0,
    afternoonAmount: medicationSchedule.afternoonAmount || 0,
    eveningAmount: medicationSchedule.eveningAmount || 0,
    notes: medicationSchedule.notes || '',
    combinedDrugs: medicationSchedule.combinedDrugs || [],
    ...(medicationSchedule.isNew && { isNew: true }),
    guidelines: medicationSchedule.guidelines,
  };
}
